import { DeepBoxError } from '@/models'
import DeepErrorHandlerService from '@/services/DeepErrorHandlerService'
import { DeepAppIcon } from '@deepcloud/deep-ui-lib'
import i18n from '@/plugins/i18n'
import { useApi } from '@/composables/api'
import { useKeycloak } from '@/composables/auth/keycloak'
import type { KeycloakLoginOptions } from 'keycloak-js'
import type { RouteLocationNormalized } from 'vue-router'

export default async function ({
  to,
  params,
}: {
  to: RouteLocationNormalized
  params: Partial<KeycloakLoginOptions>
}) {
  const { isAuthenticated, user, login, register, logout } = useKeycloak()
  const { deepAdminAPI } = useApi()

  let p = { ...params }

  const queryEmail = to.query.email as string
  const queryMailRef = to.query?.['mail-ref'] as string

  if (queryEmail && queryMailRef) {
    p = {
      ...p,
      loginHint: queryEmail,
    }

    if (isAuthenticated.value) {
      if (
        user.value?.email &&
        user.value.email.toLowerCase() !== queryEmail.toLowerCase()
      ) {
        DeepErrorHandlerService.error(
          new DeepBoxError(
            i18n.global.t('deepmail.error.logged_in_wrong_account.message', {
              userEmail: user.value?.email,
              queryEmail,
            }),
            {
              title: i18n.global.t(
                'deepmail.error.logged_in_wrong_account.title',
              ),

              imgComponent: h(DeepAppIcon, { logo: 'deepmail' }),
              btn: {
                text: i18n.global.t('actions.logout'),
                onClick: () => {
                  logout(p)
                },
              },
            },
          ),
        )
        return false
      }
      return
    }

    try {
      const { data } = await deepAdminAPI.value.usersCheckEmail.create({
        email: queryEmail,
        key: queryMailRef,
      })

      if (data.is_valid) {
        return login(p)
      } else {
        return register({ ...p, prompt: 'force_login_hint' })
      }
    } catch {
      // fallback if API fails
      return login(p)
    }
  }
}
